"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCamelCase = exports.toSnakeCase = exports.capitalize = exports.toUpperCase = exports.toLowerCase = void 0;
/* eslint-disable import/prefer-default-export */
function toLowerCase(str) {
    return str.toLowerCase();
}
exports.toLowerCase = toLowerCase;
function toUpperCase(str) {
    return str.toUpperCase();
}
exports.toUpperCase = toUpperCase;
function capitalize(str) {
    return (str.charAt(0).toUpperCase() + str.slice(1));
}
exports.capitalize = capitalize;
function toSnakeCase(str) {
    return str
        .replace(/([A-Z]{2,})/g, (letter) => letter.toLowerCase())
        .replace(/(\s[A-Za-z])/g, (group) => group.toLowerCase().replace(/[\s]/, '_'))
        .replace(/[A-Z]/g, (letter, index) => {
        return index == 0 ? letter.toLowerCase() : '_' + letter.toLowerCase();
    });
}
exports.toSnakeCase = toSnakeCase;
function toCamelCase(str) {
    return str.replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace(/[-_]/, ''));
}
exports.toCamelCase = toCamelCase;
//# sourceMappingURL=string.js.map